import { EventType, type BaseEvent } from '@ag-ui/client'
import { shortJson } from './json'

export function summarizeEvent(event: BaseEvent): string {
  const summary = (() => {
    switch (event.type) {
      case EventType.TEXT_MESSAGE_CONTENT:
        return 'delta' in event ? event.delta : 'text delta'
      case EventType.TOOL_CALL_START:
        return 'toolCallName' in event ? event.toolCallName : 'tool call'
      case EventType.TOOL_CALL_ARGS:
        return 'delta' in event ? event.delta : 'tool args'
      case EventType.TOOL_CALL_RESULT:
        return 'content' in event ? event.content : 'tool result'
      case EventType.ACTIVITY_SNAPSHOT:
        return 'activityType' in event
          ? event.activityType
          : 'activity snapshot'
      case EventType.RUN_ERROR:
        return 'message' in event ? event.message : 'run error'
      case EventType.REASONING_MESSAGE_CONTENT:
        return 'delta' in event ? event.delta : 'reasoning delta'
      default:
        return shortJson(event)
    }
  })()

  return typeof summary === 'string' ? summary : shortJson(summary)
}
